import { render, staticRenderFns } from "./paypal.vue?vue&type=template&id=2223f9fe&scoped=true"
import script from "./paypal.vue?vue&type=script&lang=js"
export * from "./paypal.vue?vue&type=script&lang=js"
import style0 from "./paypal.vue?vue&type=style&index=0&id=2223f9fe&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2223f9fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2223f9fe')) {
      api.createRecord('2223f9fe', component.options)
    } else {
      api.reload('2223f9fe', component.options)
    }
    module.hot.accept("./paypal.vue?vue&type=template&id=2223f9fe&scoped=true", function () {
      api.rerender('2223f9fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/pay/paypal.vue"
export default component.exports